import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {SpThemingService} from '../../../../services/sp-theming/sp-theming.service';
import {RoleUtils} from '../../../../utils/role/role-utils';
import {ActivatedRoute, Router} from '@angular/router';
import { SessionProviderService } from 'src/app/services/sp-authentication/session-provider.service';
import { Targeting } from 'src/app/classes/targeting/targeting';
import { toFbJsonString } from 'src/app/classes/targeting/meta-targeting';
import { NgIf } from '@angular/common';
import { AiAudienceDefinitionComponent } from '../modules/ai-audience-definition/ai-audience-definition.component';
import { SpCardSelectorComponent } from '../modules/sp-card-selector/sp-card-selector.component';

@Component({
  selector: 'app-sp-project-create-type-select',
  templateUrl: './sp-project-create-type-select.component.html',
  styleUrls: ['./sp-project-create-type-select.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    SpCardSelectorComponent,
    AiAudienceDefinitionComponent
  ]
})
export class SpProjectCreateTypeSelectComponent implements OnInit {
  // Constructor.

  freemium = false;
  folderId: string | null = null;
  showAiBuilder = false;

  @ViewChild('aiBuilderContainer') aiBuilderContainer?: ElementRef<HTMLElement>;

  constructor(private _spTheming: SpThemingService,
              private sessionProvider: SessionProviderService,
              private route: ActivatedRoute,
              private router: Router) {
    // Set the theme to use.
    this._spTheming.setSpThemeName('dashboard-desk');
  }

  // On init.
  async ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.folderId = params['folderId'] || null;
    });
    if (this.sessionProvider.activeSession) {
      this.freemium = this.sessionProvider.activeSession.user.role.level <= RoleUtils.freemiumLevel;
    }
  }

  selectTypeOfProject(type: string) {
    if(this.folderId) {
      this.router.navigate(['/projects/create/' + type], {queryParams: {folderId: this.folderId}});
    } else {
      this.router.navigate(['/projects/create/' + type]);
    }
  }

  openAiBuilder() {
    this.showAiBuilder = true;

    // Scroll to the AI builder after it's fully rendered
    // 300ms is enough time for Angular to complete change detection and update ViewChild
    setTimeout(() => {
      if (this.aiBuilderContainer?.nativeElement) {
        this.aiBuilderContainer.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  }

  async onAiAudienceConfirmed(audienceSpec: Targeting, audienceName: string): Promise<void> {
    // Navigate to facebook-interest with the AI-generated targeting.
    // Angular Router state is serialized via structured clone (history.pushState),
    // which strips class prototypes. Pass the FB JSON spec string instead so the
    // receiver can rebuild a real Targeting instance via Targeting.fromJson.
    const navigationExtras = {
      state: {
        aiGeneratedAudienceSpec: toFbJsonString(audienceSpec),
        aiGeneratedAudienceType: audienceSpec.type,
        aiGeneratedAudienceName: audienceName
      }
    };

    if (this.folderId) {
      navigationExtras['queryParams'] = { folderId: this.folderId };
    }

    this.router.navigate(['/projects/create/facebook-interest'], navigationExtras);
  }
}
